export interface FixedDimension {
  title: string;
  description: string;
}

export const TIME_DIMENSION: FixedDimension = {
  title: 'Time Sensitivity',
  description: 'Measures chronological time related to all history',
};

